import React from "react"
import { MainCP } from "../../../Components/economia/economia-v2/MainCP"
// import { NavbarCP } from "../Components/NavbarCP"
// import { FormLogin } from "./FormLogin"

const ViewEconomia: React.FC = () => <MainCP/>
  // const [showChart, setShowChart] = useState<boolean>(false);

  // const activeChart = () => {
  //   setShowChart(true);
  // }

export default ViewEconomia;


      


